// Firebase configuration for the React app
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, GoogleAuthProvider } from 'firebase/auth';

// Firebase configuration comes from the active game's config (unify Phase 3) —
// each game deploys to its own Firebase project.
import game from '../games';

const firebaseConfig = game.firebase;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);

// Initialize Google provider
const googleProvider = new GoogleAuthProvider();

// Export all initialized services
export { auth, db, onAuthStateChanged, googleProvider };
export default app; 